export type AppTab = 'collection' | 'trade' | 'progress' | 'profile'

const tabPaths: Record<AppTab,string> = {
  collection: '/collection',
  trade: '/trade',
  progress: '/progress',
  profile: '/profile',
}

export function tabFromPath(pathname:string):AppTab {
  const segment=pathname.split('/').filter(Boolean)[0]
  return segment==='trade'||segment==='progress'||segment==='profile' ? segment : 'collection'
}

export function pathForTab(tab:AppTab){return tabPaths[tab]}
